import ColumnsModal  from "./ColumnsModal";  

export default ColumnsModal